// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".row-actions-menu{overflow:visible}.row-actions-menu .vertical-dots-menu__menu-item{height:40px}.row-actions-menu .vertical-dots-menu__menu-item.ui-menu-item{font-size:14px;padding-top:0 !important;padding-bottom:0 !important}", ""]);
// Exports
module.exports = exports;
